var map = {
	"./desktop.svg": "b52c",
	"./empty.svg": "c091",
	"./filters.svg": "3b85",
	"./fix1.svg": "1e8b",
	"./fix2.svg": "3635",
	"./fix3.svg": "bb75",
	"./fix4.svg": "1f19",
	"./mac.svg": "7f2e",
	"./pad.svg": "ee74",
	"./phone.svg": "dd82",
	"./pos1.svg": "bb77",
	"./pos2.svg": "5642",
	"./pos3.svg": "8eaa",
	"./pos4.svg": "ff66",
	"./pos5.svg": "5a27",
	"./pos6.svg": "f760",
	"./pos7.svg": "cc5f",
	"./pos8.svg": "cdf5",
	"./pz.svg": "fcca",
	"./rq.svg": "41ce",
	"./screen.svg": "c081",
	"./slot.svg": "d139b",
	"./variable.svg": "598a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";